import React from 'react';
import { HalfCircleSpinner } from 'react-epic-spinners';

export const Loader = (props) => {
    return (
        <>
            {props.active ?
                <div className="loader-smsng">
                    <div className="bx-ldr">
                        <HalfCircleSpinner
                            size={40}
                            color="#000" />
                    </div>
                </div>
                :
                null
            }
        </>
    );
}